// extracted by mini-css-extract-plugin
export default {"Header":"Navigation_Header__gGOUH","Logo":"Navigation_Logo__aCeLi","fadeIn":"Navigation_fadeIn__eqgYe","active":"Navigation_active__VYNBo","menu":"Navigation_menu__TCm53"};